class MainBlog extends HTMLElement {
    constructor() {
        super();
        window.addEventListener('DOMContentLoaded', () => {
            const linkItem = document.querySelectorAll('.mobile__menu-links__item')
            const linksTitle = document.querySelectorAll('.mobile__menu-links__title')

            let domElemLinks = [];

            linkItem.forEach((links, index) => {
                const linkAttr = links.getAttribute('data-parent');

                const linkLists = linkAttr.split('-');
                const first = linkLists[0];

                if (!domElemLinks[first]) {
                    domElemLinks[first] = [];
                }

                domElemLinks[first].push(links);

            });

            const fullUrl = window.location.href;
            const convertUrl = fullUrl.split('/');

            const lastLink = convertUrl[convertUrl.length - 1];
            const parentLinklist = document.querySelectorAll('.mobile__menu-links__title');
            let ind = 0;
            for (const domElemLinksKey in domElemLinks) {
                const parentTitleAttr = parentLinklist[ind];
                ind++;
                domElemLinks[domElemLinksKey].forEach((element) => {
                    let getLinkItemValue = element.getAttribute('data-child');

                    const linkAttr = element.getAttribute('data-parent');

                    const linkLists = linkAttr.split('-');

                    if (getLinkItemValue.includes('/')) {
                        getLinkItemValue = getLinkItemValue.split('/')[0];
                    }

                    if (getLinkItemValue === lastLink || lastLink === linkLists[0]) {
                        domElemLinks[domElemLinksKey].forEach((el) => {
                            el.style.setProperty('display', 'block');
                            parentTitleAttr.classList.add('active__parent-link')
                        })
                    }
                })
            }
        })
    }
}

customElements.define('main-blog', MainBlog)
